export enum ImageMime {
  None = '',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
}

export enum VideoMime {
  None = '',
  MP4 = 'video/mp4',
}

export enum TextMime {
  None = '',
  CSV = 'text/csv',
  JSON = 'application/json',
}

export type FileMime = ImageMime | VideoMime | TextMime;

export const BYTES_PER_MB = 1048576;
